import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from '../../../../../../core/infrastructure/linq';
import { ServiceModel } from '../../../../../../store/self-diagnostic/service-catalog/model';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { Subscription } from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import { DomSanitizer } from '@angular/platform-browser';
import { TopServiceModel } from '../../../../../../store/self-diagnostic/top-service/model';

@Component({
  selector: 'admin-dashboard-top-service-create',
  templateUrl: './top-service-create.component.html',
  styleUrls: ['./top-service-create.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class TopServiceCreateComponent implements OnInit, OnDestroy {
  sanitizer = inject(DomSanitizer);
  translate = inject(TranslateService);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);

  public entity: TopServiceModel = new TopServiceModel();
  @Output('onSave') public onSave$ = new EventEmitter<TopServiceModel>();

  private services: List<ServiceModel> = new List<ServiceModel>();
  private serviceCatalogFacadeSubsription: Subscription;

  public searchDataSource: DataSource;
  public selectedMenuItem: ServiceModel;

  public ngOnDestroy() {
    this.serviceCatalogFacadeSubsription?.unsubscribe();
  }

  public ngOnInit(): void {
    this.serviceCatalogFacadeSubsription = this.serviceCatalogFacade.filtered$.subscribe(s$ => {
      if (s$) {
        this.services = new List<ServiceModel>(s$);
      }
    });

    this.searchDataSource = new DataSource({
      key: 'ID',
      load: loadOptions => {
        let result = new List<ServiceModel>();

        if (loadOptions.searchValue) {
          let searchString = loadOptions.searchValue.toLowerCase();

          result.AddRange(
            this.services
              .Where(s => s.nameUa.toLowerCase().includes(searchString) || s.nameRu.toLowerCase().includes(searchString))
              .ToArray()
          );

          result.AddRange(
            this.services
              .Where(s => s.keyWords != null)
              .Where(s =>
                new List(
                  s.keyWords
                    .split(',')
                    .map(key => key.trim().toLowerCase())
                    .filter(key => key.includes(searchString))
                ).Any()
              )
              .ToArray()
          );

          result = result.DistinctBy(s => s.id);
        }

        return result.ToArray();
      },
    });
  }

  public save() {
    this.entity.serviceId = this.selectedMenuItem?.id;

    this.onSave$.emit(this.entity);

    this.entity = new TopServiceModel();
    this.selectedMenuItem = null;
  }
}
